import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { PROJECTS } from "../../utils/constants";

export const createProject = async (data: ProjectType) => await post<ProjectType, string>(PROJECTS, data);
export const updateProject = async (data: ProjectType) => await put<ProjectType, string>(PROJECTS, data);

export const getProjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${PROJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ProjectType>>(url);
};
